import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import db from './lib/instant';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import MyTasks from './pages/MyTasks';
import Login from './pages/Login';
import Layout from './components/Layout';


function App() {
  // Use InstantDB's built-in auth components
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <db.SignedIn>
          <AuthenticatedApp />
        </db.SignedIn>
        <db.SignedOut>
          <Login />
        </db.SignedOut>
      </div>
    </Router>
  );
}

function AuthenticatedApp() {
  const user = db.useUser();
  
  return (
    <Routes>
      <Route path="/" element={<Layout><Dashboard /></Layout>} />
      <Route path="/projects" element={<Layout><Projects /></Layout>} />
      <Route path="/projects/:projectId" element={<Layout><ProjectDetail /></Layout>} />
      <Route path="/my-tasks" element={<Layout><MyTasks /></Layout>} />
      <Route path="/login" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;